import { gql, useFragment } from "@apollo/client";
import React from "react";
import { MembershipDetails } from "./MembershipDetails";

export const MEMBERSHIP_DETAILS_FRAGMENT = gql`
  fragment MembershipDetailsFragment on MembershipDetails {
    id
    details {
      perks
    }
  }
`;

export const MembershipDetailsWrapper: React.FC<{
  variant?: string;
}> = ({ variant }) => {
  const { data } = useFragment({
    fragment: MEMBERSHIP_DETAILS_FRAGMENT,
    from: {
      __typename: "MembershipDetails",
      id: "MembershipDetails"
    },
    fragmentName: "MembershipDetailsFragment"
  });

  if (!data?.details) {
    return <></>;
  }

  return (
    <MembershipDetails membershipCardDetails={data.details} variant={variant} />
  );
};
